import { useAuthorized } from './useAuthorized';

export function Unauthorized({ children }: { children: JSX.Element }) {
  const authorized = useAuthorized();

  return authorized ? null : children;
}
